import * as THREE from 'three';
import { Mask } from './Mask';
import { Player } from '../game/Player';
import { Game } from '../game/Game';

export class ApolloMask extends Mask {
  private game: Game;
  private lightSource: THREE.PointLight | null = null;
  
  constructor(player: Player, game: Game) {
    super(
      'Mask of Apollo',
      'Reveal hidden paths with divine light',
      0xffeb3b, // Yellow
      player
    );
    
    this.game = game;
    this.maxAbilityDuration = 8; // 8 seconds of light
    this.cooldownTime = 5; // 5 second cooldown
  }
  
  protected onActivate(): void {
    this.player.hasLightAura = true;
    
    // Create light source attached to player
    this.lightSource = new THREE.PointLight(0xffffcc, 1, 15);
    this.lightSource.castShadow = false;
    this.game.getScene().add(this.lightSource);
  }
  
  protected onDeactivate(): void {
    this.player.hasLightAura = false;
    
    if (this.lightSource) {
      this.game.getScene().remove(this.lightSource);
      this.lightSource = null;
    }
  }
  
  protected onUpdate(_deltaTime: number): void {
    // Update light position to follow player
    if (this.lightSource) {
      this.lightSource.position.copy(this.player.position);
      
      // Increase intensity when ability is active
      this.lightSource.intensity = this.abilityActive ? 3 : 1;
      this.lightSource.distance = this.abilityActive ? 30 : 15;
    }
  }
  
  protected onAbilityStart(): void {
    // Intense burst of light - reveals hidden objects
    // This is handled by puzzle elements checking hasLightAura
  }
  
  protected onAbilityEnd(): void {
    // Light dims back to normal
  }
}
